import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { geoLine } from '../location/profile/LocationProfileSEO';
import SortMenuButton from './SearchForm/SearchFilterAndSort/SortMenuButton';
import { SearchSupplierSortType } from '../../types/supplier/SearchSupplierSortType';

interface SearchResultsHeadingProps {
  city?: string;
  state?: string;
  count?: number;
  sort: SearchSupplierSortType;
  onSortChange: (sort: SearchSupplierSortType) => void;
}

/**
 * The results header: title and count on the left, sort on the right.
 * The title is the city search page's only heading. Crawlers previously saw a page with no
 * H1 at all, so Google preferred a single yard over the city list for
 * "truck parking in <city>" queries. Same wording as the location page's geo
 * line and the meta description, so page text and snippet agree. It wraps on
 * phones rather than truncating: cut to one line, it lost the city it names.
 * No city (a map drag) → no title, but the sort stays.
 */
const SearchResultsHeading = ({ city, state, count, sort, onSortChange }: SearchResultsHeadingProps) => (
  <Stack direction="row" alignItems="center" justifyContent="space-between" gap={2}
         sx={{ px: 2, py: 1.25, bgcolor: '#FAFAFA', borderTop: 1, borderColor: 'divider' }}>
    <Box sx={{ minWidth: 0 }}>
      {city && state && (
        <Typography component="h1" sx={{ fontWeight: 600, fontSize: '1.125rem', lineHeight: 1.3 }}>
          {geoLine(city, state)}
        </Typography>
      )}
      {count !== undefined && (
        <Typography variant="caption" color="text.secondary">{count} {count === 1 ? 'location' : 'locations'}</Typography>
      )}
    </Box>
    <SortMenuButton value={sort} onChange={onSortChange} />
  </Stack>
);

export default SearchResultsHeading;
